import mobile from "../images/moblie.jpg"
import headphone from "../images/headphone.png"
import image2 from "../images/jaket.jpg"
import image3 from "../images/laptop.jpg"
import image4 from "../images/car.jpg"

export const PRODUCT=[
    {
        id:1,
        productName:"Mobile",
        price:200,
        productImage:mobile
    },
    {
        id:2,
        productName:"headPhone",
        price:100,
        productImage:headphone
    },
    {
        id:3,
        productName:"Jaket",
        price:70,
        productImage:image2
    },
    {
        id:4,
        productName:"Lap Top",
        price:800,
        productImage:image3
    },
    {
        id:5,
        productName:"Car",
        price:7000,
        productImage:image4
    },
    
]